import { ApiResponse } from '@shared/models/api.model';
import axiosInstance from '../axios-instance';
import { MusicModel } from '@modules/entertainment/models/music.models';

export const getMusics = async (
  params?: any
): Promise<ApiResponse<MusicModel>> => {
  const response = await axiosInstance.get('/media/music/getter', { params });
  return response.data;
};

export const createMusic = async (
  body?: any
): Promise<ApiResponse<MusicModel>> => {
  return await axiosInstance.post(`/media/music`, body);
};

export const editMusicRow = async (
  body: any,
  id: any
): Promise<ApiResponse<MusicModel>> => {
  return await axiosInstance.put(`/media/music/${id}`, body);
};

export const deleteMusic = async (id: string): Promise<void> => {
  return await axiosInstance.delete(`/media/music/${id}`);
};

export const deleteMusicsMany = async (id: string[]): Promise<void> => {
  const data = { ids: id };
  await axiosInstance.delete(`/media/music/many`, { data });
};
